import { AfterViewInit, Component, Inject, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { AngularMigrationHelperService } from 'src/ajs-app/services/angularMigrationHelper.service';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { environment } from 'src/environments/environment';

/**
 * It turned out the number of angularJS digests triggered by the UpgradeModule was too high,
 * and while the app didn't feel noticeably slower on most computers,
 * some users did complain that the app felt much slower.
 * Hence we now use downgradeModule() instead of UpgradeModule (see https://angular.io/guide/upgrade-performance )
 *
 * This has the consequence that downgraded services are not available until Angular has been bootsrapped,
 * which in turns only happens when a downgraded component is rendered.
 * Hence, this component is inserted in index.html to make sure Angular is started
 * and we can use downgraded services.
 *
 * Note that some services, such as LoginFactory, are used during angularJS run() phase,
 * and hence cannot use downgraded Angular injectables.
 *
 * Thanks https://stackoverflow.com/a/51175142
 * and especially bryan60's comment on that answer for the trick of defering ui-router's routing
 */
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'angular-boostrap',
  template: '',
})
export class AngularBootstrapComponent implements AfterViewInit, OnDestroy {
  private subscriptions = new Subscription();

  constructor(
    private ajsMigrationHelperService: AngularMigrationHelperService,
    private alcmeonContextService: AlcmeonContextService,
    @Inject('$rootScope') $rootScope: any,
    @Inject('$state') $state: any
  ) {
    $rootScope.$on('$stateChangeSuccess', () => this.alcmeonContextService.siteIdBS.next($state.params.siteId));
  }

  ngAfterViewInit() {
    console.log('AngularBootstrapComponent - starting UI router');
    this.ajsMigrationHelperService.startAngularJSRouter();

    if (environment.bundledWithAngularJSApp) {
      this.subscriptions.add(
        this.ajsMigrationHelperService.ajsJWT$.subscribe(jwt => this.alcmeonContextService.setJwt(jwt))
      );
    } else {
      console.error('angular-boostrap should only be used when bundled with angularJS app');
    }
  }

  ngOnDestroy() {
    this.subscriptions?.unsubscribe();
  }
}
